import Typography from "@portal/components/atoms/v2/typography";
import { useState } from "react";
import { MainBox } from "../components/mainBox";
import { MapValuesToIndex, MapIndexToValues } from "../components/helpers/MapData";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { useAppDispatch, useAppSelector } from "@portal/redux/store";
import { setSavingsToday } from "@portal/redux/reducers/riskLevelReducer";
import { InfoBoxComponent } from "@portal/components/atoms/infoBox";
import { SelectionBoxComponent } from "../components/selectionBox/SelectionBoxComponent";
import { RobotFooterComponent } from "../components/footer";
import { TextLine } from "@portal/components/atoms/v2/textLine";

export const SavingsPage = ({ centerId, pageIndex, isDefaultLanguage }: IPageProps) => {
  const dispatch = useAppDispatch();
  const savingsToday = useAppSelector(state => state.persisted.riskLevel).request.savingsToday;

  const [selectedOption, setSelectedOption] = useState<number | null>(MapValuesToIndex(savingsToday));
  const isButtonDisabled = savingsToday === null || selectedOption === null;

  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_9_A, texts.PAGE_9_B, texts.PAGE_9_C];

  const OnSelectionClick = (selectedOption: number) => {
    setSelectedOption(selectedOption);
    const result = MapIndexToValues(selectedOption);
    if (result !== null) dispatch(setSavingsToday(MapIndexToValues(selectedOption)));
  };

  return (
    <>
      <MainBox>
        <Typography variant="H6">{texts.PAGE_9_SUBHEADER}</Typography>
        <TextLine />
        <InfoBoxComponent header={texts.TEXT_QUESTION} texts={[texts.PAGE_9_INFO_BOX]} marginTop={10} />
        <SelectionBoxComponent options={options} selectedOption={selectedOption} onSelectionClick={OnSelectionClick} />
      </MainBox>
      <RobotFooterComponent
        pageIndex={pageIndex}
        centerId={centerId}
        primaryButtonText={texts.BUTTON_NEXT}
        secondaryButtonText={texts.BUTTON_BACK}
        disabled={isButtonDisabled}
      />
    </>
  );
};
